(() => {
  const dialog = document.querySelector('#CartDialog');
  const overlay = document.querySelector('#CartOverlay');
  let lastFocus;
  function closeCart() { if (overlay) overlay.hidden = true; document.body.style.overflow = ''; lastFocus?.focus(); }
  function openCart() { overlay.hidden = false; document.body.style.overflow = 'hidden'; dialog.querySelector('[data-close-cart]').focus(); }
  overlay?.addEventListener('click', event => { if (event.target === overlay) closeCart(); });
  document.addEventListener('keydown', event => {
    if (!overlay || overlay.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); closeCart(); }
    if (event.key === 'Tab') {
      const focusable = [...dialog.querySelectorAll('button, a[href], input, select')].filter(el => !el.disabled);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  document.querySelectorAll('[data-close-cart]').forEach(button => button.addEventListener('click', closeCart));
  document.addEventListener('click', event => {
    const navLink = event.target.closest('.mobile-nav a');
    if (navLink) navLink.closest('details').open = false;
    if (event.target.matches('[data-dismiss-preview]')) event.target.parentElement.remove();
  });
  function initialize(scope = document) {
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      section.querySelectorAll('.gallery-thumb[data-image]').forEach(button => button.addEventListener('click', () => {
        const image = section.querySelector('.product-image');
        image.src = button.dataset.image; image.removeAttribute('srcset'); image.alt = button.dataset.alt;
        section.querySelectorAll('.gallery-thumb[data-image]').forEach(item => { item.classList.toggle('is-active', item === button); item.setAttribute('aria-pressed', item === button ? 'true' : 'false'); });
      }));
      section.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {
        const input = section.querySelector('[name="quantity"]');
        input.value = Math.min(99, Math.max(1, (parseInt(input.value, 10) || 1) + Number(button.dataset.quantity)));
      }));
      const form = section.querySelector('[data-product-form]');
      if (!form) return;
      const select = form.querySelector('[data-variant-select]');
      const button = form.querySelector('[name="add"]');
      const label = button.querySelector('[data-button-text]');
      const status = form.querySelector('[data-form-message]');
      function updateVariant() {
        const option = select.selectedOptions[0];
        const available = option.dataset.available === 'true';
        section.querySelectorAll('[data-variant]').forEach(el=>el.setAttribute('aria-pressed',el.dataset.variant===option.value?'true':'false'));
        if(option.dataset.image){const image=section.querySelector('.product-image');image.src=option.dataset.image;image.removeAttribute('srcset');image.alt=option.textContent;}
        if(document.body.dataset.productPage==='true'){const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);}
        section.querySelector('[data-product-price]').textContent = option.dataset.price;
        section.querySelector('[data-stock]').textContent = available ? button.dataset.availableLabel : button.dataset.soldLabel;
        button.disabled = !available; label.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
      }
      select.addEventListener('change', updateVariant);
      section.querySelectorAll('[data-variant]').forEach(el=>el.addEventListener('click',()=>{select.value=el.dataset.variant;select.dispatchEvent(new Event('change',{bubbles:true}));}));
      form.addEventListener('submit', async event => {
        if (!window.fetch || !overlay) return;
        event.preventDefault();
        if (button.disabled || !form.reportValidity()) return;
        button.disabled = true; label.textContent = button.dataset.busyLabel; status.textContent = '';
        try {
          const response = await fetch(form.action.replace(/\/$/, '') + '.js', {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : button.dataset.errorLabel);
          const summary = dialog.querySelector('[data-cart-summary]');
          summary.replaceChildren();
          const row = document.createElement('div'); row.className = 'drawer-product';
          if (result.image) { const image = document.createElement('img'); image.src = result.image; image.alt = result.product_title; row.append(image); }
          const text = document.createElement('div');
          const title = document.createElement('strong'); title.textContent = result.product_title;
          const detail = document.createElement('p'); detail.textContent = `${result.variant_title || ''} · ${form.querySelector('[name="quantity"]').value} × ${select.selectedOptions[0].dataset.price}`;
          text.append(title,detail); row.append(text); summary.append(row);
          lastFocus = button; openCart();
          const root = window.Shopify?.routes?.root || '/';
          fetch(root + 'cart.js', {headers:{Accept:'application/json'}}).then(r => r.ok ? r.json() : Promise.reject()).then(cart => document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count)).catch(() => {});
        } catch (error) { status.textContent = error.message || button.dataset.errorLabel; }
        finally { updateVariant(); }
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
